import React from 'react'
import { withTranslation } from 'react-i18next'
import styles from './NotEligibleFishingTruck.module.scss'
import { useHistory } from 'react-router-dom'

const NotEligibleView = ({ t, i18n }) => {
  const history = useHistory()
  const getPhoneNumber = (text) => {
    return `tel:${t(text)}`
  }

  return (
    <div>
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-lg-8">
            <h1>{t('title')}</h1>
            <h3>{t('not_eligible_fishing.you_are_not')}</h3>
            <p>{t('not_eligible_fishing.if_you_need')}<a href={getPhoneNumber('not_eligible_fishing.number')}>{t('not_eligible_fishing.number')}</a>{t('not_eligible_fishing.if_you_need_info')}</p>
          </div>
        </div>
        <div className={styles['margin_back']}>
          <div className="row">
            <div className="col-xs-12 col-lg-8">
              <a
                onClick={() => history.push(`/${i18n.language}${t('routes.eligibility_question_fishing')}`)}
                href={`/${i18n.language}${t('routes.eligibility_question_fishing')}`}
              >
                {t('not_eligible_fishing.back')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default withTranslation('common')(NotEligibleView)